(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  //   document.addEventListener('DOMContentLoaded', function() {
  //   const logo = document.querySelector(".footer-large-logo");
  //   const footer = document.querySelector("footer");

  //   if (!logo || !footer) return;

  //   let lastScrollPosition = window.scrollY;
  //   let scale = 1.;
  //   let opacity = 1;

  //   window.addEventListener("scroll", () => {
  //     const currentScrollPosition = window.scrollY;
  //     if (currentScrollPosition < lastScrollPosition) {
  //       scale = Math.max(0.5, scale - 0.01);
  //       opacity = Math.max(0.5, opacity - 0.01);

  //     } else {
  //       scale = Math.min(1, scale + 0.02);
  //       opacity = Math.min(1, opacity + 0.02);
  //     }
  //     logo.style.transform = `scale(${scale})`;
  //     logo.style.opacity = opacity;
  //     logo.style.transition = "transform 0.1s ease, opacity 0.1s ease";
  //     lastScrollPosition = currentScrollPosition;
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');     
      this.headerIsOnSticky = this.getAttribute('data-sticky-type') === 'sticky';
    
      if (this.headerIsOnSticky) {
          this.header.classList.add('wdt-scroll-sticky');
      
          const wdtHeaderEle = document.querySelector('.wdt-scroll-sticky');
          const wdt_MaxScroll = 800;
          let wdtHeaderHeight = this.header.offsetHeight;
          let position = window.scrollY;
         
          const updateHeaderHeight = () => {
              wdtHeaderHeight = this.header.offsetHeight;
          };
        
          window.addEventListener('scroll', function() {
            var wdtScrollTop = window.scrollY;             
            if ((wdtScrollTop > 0 && position > wdt_MaxScroll) && wdtScrollTop > position) {
                wdtHeaderEle.classList.add('wdt-header-top');
                wdtHeaderEle.style.top = `-${wdtHeaderHeight}px`;
            } else {
                wdtHeaderEle.classList.remove('wdt-header-top');
                wdtHeaderEle.style.top = '0px';
            }
            position = wdtScrollTop;
          });

        window.addEventListener('resize', updateHeaderHeight);
        
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);


  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-target]").forEach((button) => {
    button.addEventListener("click", function () {
      const targetSelector = this.getAttribute("data-target");
      const offcanvasElement = document.querySelector(targetSelector);

      if (offcanvasElement) {
        const bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
        bsOffcanvas.show();
      }
    });
  });

    document.querySelectorAll('a[role="button"]').forEach(button => {
  button.addEventListener('keydown', function(e) {
    if (e.code === 'Space' || e.key === ' ') {
      e.preventDefault(); 
      this.click(); 
    }
  });
});

 const subMenu = () => {
      const dropdown_subMenu = document.querySelectorAll(".dropdown-menu.sub-menu");
      const documentBody = document.querySelector("body");
      const window_Width = documentBody.clientWidth;
    
      dropdown_subMenu.forEach((item) => {
        const thisItemRight = item.getBoundingClientRect().right;
    
        if (window_Width < thisItemRight) {
          item.classList.add("wdt_float_left");
        } else {
          item.classList.remove("wdt_float_left");
        }
      });
    };
    
    subMenu();
    window.addEventListener("resize", subMenu);

        
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    this.newsletterModal = null;
    this.closeButton = null;
    this.focusableElements = [];
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.previouslyFocusedElement = null;
    this.subscriptionForm = null;
  }

  connectedCallback() {
    this.initModal();
  }

  initModal() {
    this.newsletterModal = this.querySelector("#newsletter_model");
    this.closeButton = this.querySelector("#newsletter_model .btn-close");
    this.subscriptionForm = this.newsletterModal?.querySelector('form[action*="contact"]') || 
                           this.newsletterModal?.querySelector('form[action*="newsletter"]') ||
                           this.newsletterModal?.querySelector('form');

    if (!this.newsletterModal) return;

    const isThemeEditor = window.Shopify && window.Shopify.designMode;
    const delay = parseInt(this.newsletterModal.dataset.delay || "0", 10);
    const expiryDays = parseInt(this.newsletterModal.dataset.expiry || "30", 10);
    const hasSubscribed = this.getCookie("newsletter_subscribed");
    const closedAfterSubscription = this.getCookie("newsletter_closed_after_subscription");
    
    if (hasSubscribed && !closedAfterSubscription) {
      setTimeout(() => this.showModal(), delay);
    } else if (!hasSubscribed && !isThemeEditor && this.getCookie("newsletter_closed")) {
      return;
    } else if (!hasSubscribed && !isThemeEditor) {
      setTimeout(() => this.showModal(), delay);
    }

    this.initEventListeners(expiryDays);
    this.initSubscriptionListener();
  }

  initSubscriptionListener() {
    if (!this.subscriptionForm) return;
    this.subscriptionForm.addEventListener("submit", (e) => {
      setTimeout(() => {
        this.handleSubscriptionSuccess();
      }, 500);
    });
    document.addEventListener("newsletter:subscribed", () => {
      this.handleSubscriptionSuccess();
    });

    if (window.Shopify && this.subscriptionForm) {
      this.subscriptionForm.addEventListener("shopify:form:success", () => {
        this.handleSubscriptionSuccess();
      });
    }
  }

  handleSubscriptionSuccess() {
    this.setCookie("newsletter_subscribed", "true", 365);
    this.deleteCookie("newsletter_closed");
    this.deleteCookie("newsletter_closed_after_subscription");
    this.hideModal();
    setTimeout(() => {
      this.showModal();
    }, 1000);
  }

  initEventListeners(expiryDays) {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.handleClose(expiryDays);
      });
    }

    document.addEventListener("click", (event) => {
      if (
        this.newsletterModal.classList.contains("d-flex") &&
        !event.target.closest(".popup-modal") &&
        !event.target.classList.contains("trigger")
      ) {
        this.handleClose(expiryDays);
      }
    });

    this.newsletterModal.addEventListener("keydown", (e) => {
      this.trapFocus(e);
      this.handleEscKey(e, expiryDays);
    });
  }

  handleClose(expiryDays) {
    this.hideModal();
  
    const hasSubscribed = this.getCookie("newsletter_subscribed");
    
    if (hasSubscribed) {
      this.setCookie("newsletter_closed_after_subscription", "true", expiryDays);
    } else {
      this.setCookie("newsletter_closed", "true", expiryDays);
    }
  }

  showModal() {
    this.newsletterModal.classList.remove("d-none");
    this.newsletterModal.classList.add("d-flex");
    this.newsletterModal.setAttribute("tabindex", "-1");
    this.newsletterModal.setAttribute("role", "dialog");
    this.newsletterModal.setAttribute("aria-modal", "true");
    this.previouslyFocusedElement = document.activeElement;
    
    this.waitUntilVisible(() => {
      this.focusableElements = Array.from(
        this.newsletterModal.querySelectorAll(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(el => !el.disabled && el.offsetParent !== null);
      
      this.firstFocusable = this.focusableElements[0];
      this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
      
      const emailInput = this.newsletterModal.querySelector('input[type="email"]');
      if (emailInput) {
        this.safeFocus(emailInput);
      } else if (this.firstFocusable) {
        this.safeFocus(this.firstFocusable);
      } else {
        this.safeFocus(this.newsletterModal);
      }
      
      document.body.style.overflow = "hidden";
    });
  }

  hideModal() {
    if (this.newsletterModal) {
      this.newsletterModal.classList.remove("d-flex");
      this.newsletterModal.classList.add("d-none");
      this.newsletterModal.style.setProperty("display", "none", "important");
    }

    const popupModal = this.querySelector(".popup-modal");
    if (popupModal) popupModal.style.setProperty("display", "none", "important");

    document.body.style.overflow = "";

    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus({ preventScroll: true });
    }
  }

  trapFocus(e) {
    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusable) {
        e.preventDefault();
        this.lastFocusable?.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusable) {
        e.preventDefault();
        this.firstFocusable?.focus();
      }
    }
  }

  handleEscKey(e, expiryDays) {
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      this.handleClose(expiryDays);
    }
  }

  safeFocus(el) {
    let attempts = 0;
    const tryFocus = () => {
      if (this.isVisible(el)) {
        el.focus({ preventScroll: true });
      } else if (attempts < 20) {
        attempts++;
        requestAnimationFrame(tryFocus);
      }
    };
    tryFocus();
  }

  waitUntilVisible(callback) {
    let tries = 0;
    const check = () => {
      if (this.isVisible(this.newsletterModal)) {
        callback();
      } else if (tries < 20) {
        tries++;
        requestAnimationFrame(check);
      }
    };
    check();
  }

  isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
  }

  getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=${new Date(Date.now() - 1000).toUTCString()}; path=/;`;
  }
}

customElements.define("newsletter-modal", NewsletterModal);

document.addEventListener("DOMContentLoaded", () => {
  const newsletterModalElement = document.querySelector("newsletter-modal");
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
function initWdtIcon(){
  let wdtIconItem = document.querySelectorAll('.text-with-icon-item');

  wdtIconItem.forEach(wdtItem => {
    let wdtItem_height = wdtItem.clientHeight / 2;
    let wdtItem_parent = wdtItem.closest('.section-text-with-icon');
    wdtItem_parent.setAttribute('style', `--before-top: ${wdtItem_height}px;`);
  });
}
  initWdtIcon();

  } catch(e) { console.error(e); }
})();
})();
